import Countdowns from "./countdown/Countdowns";

document.addEventListener('DOMContentLoaded', () => {
    new Countdowns().start();
});
